import { render, staticRenderFns } from "./HorizontalBrandTileGrid.vue?vue&type=template&id=e95dea20&scoped=true&"
import script from "./HorizontalBrandTileGrid.vue?vue&type=script&lang=ts&"
export * from "./HorizontalBrandTileGrid.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalBrandTileGrid.vue?vue&type=style&index=0&id=e95dea20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95dea20",
  null
  
)

export default component.exports